import { Box, Tabs } from '@inflearn/ds-react-next';
import { SUPPORTED_LANGUAGES, useLang } from '@inflearn/i18n-tools';
import { find } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const POLICY_CATEGORY = [
  { title: '통합서비스 이용약관', href: '/policy' },
  { title: '인프런 이용약관', href: '/policy/terms-of-service' },
  { title: '개인정보 처리방침', href: '/policy/privacy' },
  { title: '인프런 비즈니스 이용약관', href: '/policy/business-terms' },
] as const;

const POLICY_CATEGORY_JA = [
  { title: '특정 상거래법.short', href: '/policy/specified-commercial-transactions' },
] as const;

export const PolicyTabs = () => {
  const { lang } = useLang();
  const isJa = lang === SUPPORTED_LANGUAGES.ja;

  const { t } = useTranslation();
  const router = useRouter();

  const getActiveTabValue = () => {
    if (router.pathname.includes('/previous-terms-of-service')) {
      return find(POLICY_CATEGORY, { title: '인프런 이용약관' })?.href;
    }

    if (router.pathname.includes('/previous-privacy')) {
      return find(POLICY_CATEGORY, { title: '개인정보 처리방침' })?.href;
    }

    if (isJa && router.pathname.includes('/specified-commercial-transactions')) {
      return find(POLICY_CATEGORY_JA, { title: '특정 상거래법.short' })?.href;
    }

    return router.pathname;
  };

  const activeTabValue = getActiveTabValue();
  const tabsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 탭이 화면보다 넓으면 선택된 탭이 가로 스크롤 밖에 있을 수 있다. DS Tabs 는 스크롤 위치를 다루는 옵션이 없다.
    const scrollContainer = tabsRef.current?.querySelector<HTMLElement>(
      '.inflearn-tabs-scroll-container',
    );
    const activeTab = tabsRef.current?.querySelector<HTMLElement>('[role="tab"][data-active]');

    if (!scrollContainer || !activeTab) {
      return;
    }

    const containerRect = scrollContainer.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();
    scrollContainer.scrollLeft +=
      tabRect.left - containerRect.left - (containerRect.width - tabRect.width) / 2;
  }, []);

  return (
    <Box ref={tabsRef} w="100%">
      <Tabs value={activeTabValue} w="100%" pt={32} wrap="nowrap">
        <Tabs.List w="100%">
          {POLICY_CATEGORY.map((category) => (
            <Link key={category.href} href={category.href}>
              <Tabs.Tab value={category.href}>{t(category.title)}</Tabs.Tab>
            </Link>
          ))}
          {isJa
            ? POLICY_CATEGORY_JA.map((category) => (
                <Link key={category.href} href={category.href}>
                  <Tabs.Tab value={category.href}>{t(category.title)}</Tabs.Tab>
                </Link>
              ))
            : null}
        </Tabs.List>
      </Tabs>
    </Box>
  );
};
